((app) => {
    app.component("navbar", {
        templateUrl: "/App/States/Root/Navbar/navbar.html",
        controller: navbarCtrl
    });

    navbarCtrl.$inject = ["accessTokenService"];
    function navbarCtrl(accessTokenService) {
        let $ctrl = this;

        $ctrl.$onInit = () => {
            if (accessTokenService.getAccessToken()) {
                $ctrl.hasAccess = true;
            } else {
                accessTokenService.registerListener(() => {
                    $ctrl.hasAccess = true;
                });
            }
        };
    }

})(window.app);